import BNutritionFeature from './BNutritionFeature'

export default BNutritionFeature
